<template>
    <div
        :style="{ width: width === '100%' ? '100%' : width + 'px', height: height === '100%' ? '100%' : height + 'px' }"
        class="cl_video_player"
        :class="{ small_box: width < 360 || height < 200 }"
    >
        <div class="cl_wrapper">
            <video
                ref="video_player"
                class="video-js vjs-big-play-centered video_box"
                @play="onPlayerPlay()"
                @timeupdate="onTimeUpdate()"
                @pause="onPlayerPause()"
                @loadedmetadata="onLoadedmetadata($event)"
                playsinline
            ></video>
        </div>
        <!-- 视频控制器 -->
        <div v-if="showControl" class="video_control_wrap">
            <div class="video_control">
                <div class="left">
                    <cl-svg-icon
                        v-if="!isStart"
                        class="control_icon"
                        icon-class="video_start"
                        @click.native="startAndStop('start')"
                    ></cl-svg-icon>
                    <cl-svg-icon
                        v-else
                        class="control_icon"
                        icon-class="video_stop"
                        @click.native="startAndStop('stop')"
                    ></cl-svg-icon>
                    <cl-svg-icon
                        class="control_icon"
                        icon-class="video_back5s"
                        @click.native="forwardAndBack('back')"
                    ></cl-svg-icon>
                    <cl-svg-icon
                        class="control_icon"
                        icon-class="video_forward5s"
                        @click.native="forwardAndBack('forward')"
                    ></cl-svg-icon>
                    <span class="video_time Jost">
                        {{ videoCurrentTime | formatTime }} / {{ videoTotalTime | formatTime }}</span
                    >
                </div>
                <div class="right">
                    <div class="play_speed cursor_pointer" @click="changeSpeed()" ref="speedBoxDom">
                        {{ playSpeed }}X
                        <ul v-if="isShowSpeedBar" class="speed_options" ref="speedDom">
                            <li
                                v-for="item in speedOptions"
                                :key="item"
                                @click="changePlaySpeed(item)"
                                :class="{ active: item === playSpeed }"
                            >
                                {{ item }}X
                            </li>
                        </ul>
                    </div>
                    <span class="video_volume_box">
                        <cl-svg-icon
                            v-if="volumeValue === 0"
                            class="control_icon"
                            icon-class="video_mute"
                            @click.native="volumeChange(0.5)"
                        ></cl-svg-icon>
                        <cl-svg-icon
                            v-else
                            class="control_icon"
                            icon-class="video_volume"
                            @click.native="volumeChange(0)"
                        ></cl-svg-icon>
                        <el-slider
                            class="video_volume_slider"
                            v-model="volumeValue"
                            vertical
                            height="80px"
                            :max="1"
                            :step="0.01"
                            @input="volumeChange"
                            :format-tooltip="formatTooltip"
                        >
                        </el-slider>
                    </span>
                    <cl-svg-icon
                        class="control_icon"
                        icon-class="video_fullscreen"
                        @click.native="fullScreen()"
                    ></cl-svg-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'cl-video-player',
        props: {
            // 视频的src路径
            src: {
                type: String,
                default: '',
            },
            poster: {
                type: String,
                default: '',
            },
            // 是否显示控制条
            showControl: {
                type: Boolean,
                default: true,
            },
            // 视频宽度
            width: {
                type: [Number, String],
                default: 752,
            },
            // 视频高度
            height: {
                type: [Number, String],
                default: 417,
            },
        },
        data() {
            return {
                eventCount: 0, // 事件计数
                videoPlayer: null, // 视频播放器
                videoCurrentTime: 0, // 视频当前时间
                videoTotalTime: 0, // 视频总时长
                isStart: false, // 是否开始
                playSpeed: 1, // 视频播放速度
                volumeValue: 0.3, // 音量初始值(0-1)
                isShowSpeedBar: false, // 是否显示播放速度控制条
                isShowVolumeBar: false, // 是否显示音量控制条
                speedOptions: [2, 1.5, 1.25, 1, 0.5], // 播放速度选项
            }
        },
        beforeDestroy() {
            this.videoPlayer = null
            this.removeEvent()
        },
        mounted() {
            this.initVideoJS()
        },
        filters: {
            // 格式化时间
            formatTime(result) {
                let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
                let m =
                    Math.floor((result / 60) % 60) < 10
                        ? '0' + Math.floor((result / 60) % 60)
                        : Math.floor((result / 60) % 60)
                let s = Math.floor(result % 60) < 10 ? '0' + Math.floor(result % 60) : Math.floor(result % 60)
                if (h === '00') {
                    return m + ':' + s
                } else {
                    return h + ':' + m + ':' + s
                }
            },
        },
        methods: {
            // 初始化视频
            initVideoJS() {
                let ele = this.$refs.video_player
                // video.js初始化实例化的对象
                this.videoPlayer = this.$video(ele, {
                    controls: true, // 是否显示控制条
                    preload: 'auto', // 是否预加载视频数据
                    muted: false, // 是否静音
                    language: 'zh-CN', // 设置语言
                    autoplay: false, // 自动播放
                    // poster: this.poster,
                    sources: [
                        // 视频源
                        {
                            type: this.src.indexOf('.m3u8') > 0 ? "application/x-mpegURL" : "video/mp4",
                            src: this.src,
                        },
                    ],
                    controlBar: {
                        // 设置控制条组件
                        children: [
                            { name: 'progressControl' }, // 播放进度条
                            // { name: 'fullscreenToggle' }     // 全屏按钮
                        ],
                    },
                })
            },
            // 开始视频
            onPlayerPlay() {
                this.isStart = true
            },
            // 暂停视频
            onPlayerPause() {
                this.isStart = false
            },
            // 实时更新
            onTimeUpdate() {
                this.videoCurrentTime = this.videoPlayer ? this.videoPlayer.currentTime() : 0
            },
            // 加载视频源数据
            onLoadedmetadata() {
                this.videoTotalTime = parseInt(this.videoPlayer.duration()) || 0
            },
            // 前进或后退视频(5s)
            forwardAndBack(type) {
                const space = 5
                // 最小间隔时间
                let minSpaceTime = this.videoCurrentTime - space >= 0 ? this.videoCurrentTime - space : 0
                // 最大间隔时间
                let maxSpaceTime =
                    this.videoCurrentTime + space >= this.videoTotalTime
                        ? this.videoTotalTime
                        : this.videoCurrentTime + space
                this.videoPlayer.currentTime(type === 'back' ? minSpaceTime : maxSpaceTime)
                this.videoPlayer.play()
            },
            // 开始或暂停视频
            startAndStop(type) {
                if (type === 'start') {
                    this.videoPlayer.play()
                } else {
                    this.videoPlayer.pause()
                }
            },
            // 改变播放速度
            changeSpeed() {
                this.isShowSpeedBar = !this.isShowSpeedBar
                !this.eventCount && this.addEvent()
            },
            // 添加事件(点击空白处关闭播放速度下拉框)
            addEvent() {
                this.eventCount = 1 // 事件计数+1 确保addEvent方法只执行一次
                document.addEventListener('click', this.eventMethod)
            },
            // 事件方法
            eventMethod(e) {
                let ele = this.$refs.speedDom
                let ele1 = this.$refs.speedBoxDom
                if (ele && this.isShowSpeedBar && ele1 != e.target) {
                    this.isShowSpeedBar = false // 关闭播放速度下拉框
                }
            },
            // 移除事件
            removeEvent() {
                document.removeEventListener('click', this.eventMethod)
            },
            // 改变控制条显隐
            changeVolumeBar(type) {
                let boolean = type === 'show' ? true : false
                this.isShowVolumeBar = boolean
                console.log(this.isShowVolumeBar)
            },
            // 改变视频音量
            volumeChange(volume) {
                this.volumeValue = volume || 0
                this.videoPlayer && this.videoPlayer.volume(this.volumeValue)
            },
            // 视频全屏
            fullScreen() {
                this.videoPlayer.requestFullscreen()
            },
            // 改变视频播放速度
            changePlaySpeed(item) {
                this.playSpeed = item
                this.videoPlayer.ready(function() {
                    this.playbackRate(item)
                })
            },
            // 格式化tooltip信息
            formatTooltip() {
                return (parseInt(this.volumeValue * 100) || 0) + '%'
            },
        },
    }
</script>

<style lang="scss" scoped>
    ::v-deep {
        // 视频style
        .video_box {
            width: 100%;
            height: 100%;
            video {
                border-radius: 2px;
                object-fit: cover;
            }
        }
        .video-js {
            background-color: transparent;
            border-radius: 24px;
            .vjs-slider {
                background-color: rgba(255, 255, 255, 0.36);
            }
            .vjs-control-bar {
                bottom: 40px;
                height: 5px;
                background: rgba(8, 8, 8, 0.6);
            }
            .vjs-progress-control {
                width: 100%;
            }
            .vjs-play-progress {
                background: var(--primary-color);
                &::before {
                    color: #fff;
                }
            }
            .vjs-time-tooltip {
                display: block;
                width: auto;
                word-break: normal;
                background: rgb(223, 226, 210);
            }
            &.vjs-fullscreen {
                .vjs-control-bar {
                    height: 3em;
                    bottom: 0;
                }
                video {
                    border-radius: 0;
                }
            }
            &.vjs-paused {
                .vjs-big-play-button {
                    color: #fff;
                    &::before {
                        color: #fff;
                    }
                }
            }
            &.vjs-playing {
                .vjs-big-play-button {
                    display: none;
                }
            }
        }
        // 音量滑块style
        .el-slider__button {
            width: 12px;
            height: 12px;
            border: 1px solid var(--fff6);
            background-color: #fff;
        }
    }
    .cl_video_player {
        display: inline-block !important;
        position: relative;
        &.small_box {
            .video_control {
                padding: 0 !important;
                .control_icon {
                    width: 25px !important;
                    height: 25px !important;
                    margin: 0;
                }
            }
            .video_time {
                margin-left: 0 !important;
            }
        }
        .cl_wrapper {
            width: 100%;
            height: 100%;
            border-radius: 24px;
        }
        .video_control_wrap {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 40px;
            background-color: rgba(8, 8, 8, 0.6);
            border-radius: 0px 0px 6px 6px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #fff;
            .video_control {
                height: 100%;
                flex: 1;
                display: flex;
                align-items: center;
                padding: 0 24px;
                user-select: none;
                .left,
                .right {
                    display: flex;
                    align-items: center;
                    font-size: 26px;
                    &:last-child {
                        justify-content: flex-end;
                        .control_icon {
                            margin-left: 8px;
                            margin-right: 0;
                        }
                    }
                    .video_time {
                        margin-left: 16px;
                        font-family: 'AkrobatMedium';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 20px;
                        color: #ffffff;
                    }
                    .play_speed {
                        color: #fff;
                        margin-right: 8px;
                        font-size: 12px;
                        position: relative;
                        font-family: 'AkrobatMedium';
                        font-style: normal;
                        cursor: pointer;
                        .speed_options {
                            position: absolute;
                            left: -36px;
                            bottom: 29px;
                            width: 56px;
                            background: rgba(8, 8, 8, 0.6);
                            li {
                                list-style: none;
                                height: 32px;
                                line-height: 32px;
                                text-align: center;
                                font-family: Jost;
                                font-size: 12px;
                                color: rgba(255, 255, 255, 0.8);
                                border-bottom: 2px solid rgba(8, 8, 8, 0.8);
                                position: relative;
                                cursor: pointer;
                                &.active {
                                    color: rgba(255, 255, 255, 1);
                                    &:after {
                                        content: '';
                                        position: absolute;
                                        top: 0;
                                        right: 0;
                                        width: 12px;
                                        height: 12px;
                                        background-size: 100%;
                                    }
                                }
                                &:last-child {
                                    border-bottom: 0;
                                }
                            }
                        }
                    }
                    .video_volume_box {
                        position: relative;
                        font-size: 24px;
                        height: 40px;
                        .video_volume_slider {
                            display: none;
                            box-sizing: border-box;
                            height: 90px;
                            position: absolute;
                            right: -8px;
                            top: -90px;
                            padding-top: 5px;
                            background-color: rgba(0, 0, 0, 0.36);
                        }
                        &:hover {
                            .video_volume_slider {
                                display: block;
                            }
                        }
                    }
                }
                .left {
                    flex: 1;
                }
            }
        }
    }</style
>;
